import React from 'react';

const fileContext = React.createContext({record: {
    currentFile : null,
    files: []
}});

export { fileContext };